import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import InstallAppBanner from "../InstallAppBanner/InstallAppBanner";
import "./MainLayout.css";
import SEO from "../SEO/SEO";

const MainLayout = () => {
  return (
    <div className="main-layout">
      <SEO />
      <Header />
      <InstallAppBanner />
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
